export enum enumUserRole {
  ADMINISTRATOR = 'admin',
  OPERATOR = 'operator',
  SUPERVISOR = 'supervisor',
  CUSTOMER = 'customer',
}
